/**
 * Copy text to the clipboard; resolves true only when the browser confirmed the write.
 *
 * Call it synchronously from the user's click (no awaits before it): Safari only
 * honours clipboard writes inside the user gesture. The async Clipboard API is
 * tried first; browsers without it (or insecure contexts) fall back to a
 * selection + execCommand("copy"), whose boolean result is the confirmation.
 */
export function copyToClipboard(text) {
    const value = String(text == null ? "" : text);
    if (typeof navigator !== "undefined" && navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        return navigator.clipboard
            .writeText(value)
            .then(() => true)
            .catch(() => legacyCopy(value));
    }
    return Promise.resolve(legacyCopy(value));
}

function legacyCopy(value) {
    if (typeof document === "undefined" || typeof document.execCommand !== "function") return false;
    const area = document.createElement("textarea");
    area.value = value;
    area.setAttribute("readonly", "");
    area.setAttribute("aria-hidden", "true");
    area.style.position = "fixed";
    area.style.top = "-1000px";
    area.style.opacity = "0";
    document.body.appendChild(area);
    let copied = false;
    try {
        area.select();
        area.setSelectionRange(0, value.length);
        copied = document.execCommand("copy") === true;
    } catch (e) {
        copied = false;
    } finally {
        document.body.removeChild(area);
    }
    return copied;
}
